import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar'; 
import { useLocation, Link } from 'react-router-dom';
import { Modal, Button, Form } from 'react-bootstrap';
import useAuth from '../../dashboard/useAuth';
import { BsPeople } from 'react-icons/bs';

const Ajouter_utilisateur_groupe = ({titre}) => {
    useAuth()
    const [groupeUsers, setGroupeUsers] = useState([]); 
    const [allUsers, setAllUsers] = useState([]); 
    const [selectedGroupeUsers, setSelectedGroupeUsers] = useState([]);
    const [selectedAllUsers, setSelectedAllUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [searchGroupe, setSearchGroupe] = useState('');
    const [searchAll, setSearchAll] = useState('');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const { groupe_id } = location.state || {};;

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
      if (user_id) {
        document.title = "eTrainApp | Mise en groupe"; // Définit le titre de la page
      }
    }, [user_id]);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE+`/afficher-utilisateurs-du-groupe/${groupe_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setGroupeUsers(data.utilisateurs_du_groupe);
                    setAllUsers(data.tous_utilisateurs);
                } else {
                    console.error('Erreur lors de la récupération des utilisateurs');
                }
            } catch (error) {
                console.error('Erreur:', error);
            }
        };
        fetchUsers();
    }, [groupe_id]);

    const ajouterTous = () => {
        setGroupeUsers([...groupeUsers, ...allUsers]);
        setAllUsers([]);
    };

    const ajouterSelection = () => {
        const selectedUsers = allUsers.filter(user => selectedAllUsers.includes(user.id));
        setGroupeUsers([...groupeUsers, ...selectedUsers]);
        setAllUsers(allUsers.filter(user => !selectedAllUsers.includes(user.id)));
        setSelectedAllUsers([]);
    };

    const retirerSelection = () => {
        const selectedUsers = groupeUsers.filter(user => selectedGroupeUsers.includes(user.id));
        setAllUsers([...allUsers, ...selectedUsers]);
        setGroupeUsers(groupeUsers.filter(user => !selectedGroupeUsers.includes(user.id)));
        setSelectedGroupeUsers([]);
    };

    const retirerTous = () => {
        setAllUsers([...allUsers, ...groupeUsers]);
        setGroupeUsers([]);
    };

    const handleSubmit = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE+`/enregistrer-utilisateurs-groupe/${groupe_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    utilisateurs_ids: groupeUsers.map(user => user.id)
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const responseData = await response.json();
                console.log('Succès:', responseData);
                showMessage('Les utilisateurs ont été enregistrés avec succès.');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showMessage('Erreur lors de l\'enregistrement des utilisateurs.');
        }
    };

    const [groupeData, setGroupeData] = useState({
        nom: '',
        description: '',
        acces: '',
        ajoute_par: '',
        statut: 'inactif',  // Initialisation du statut
    });

    // Utilisation de useEffect pour récupérer les données du groupe
    useEffect(() => {
        const fetchGroupeData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE+`/groupe-info/${groupe_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setGroupeData({
                        id: data.id,
                        nom: data.nom,
                        description: data.description,
                        ajoute_par: data.ajoute_par,
                        statut: data.statut,
                    });
                } else {
                    console.error('Erreur lors de la récupération des données du groupe');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };

        fetchGroupeData();
    }, [groupe_id]);

    const showMessage = (message) => {
        setModalMessage(message);
        setShowModal(true);
    };

    const handleClose = () => setShowModal(false);

    // Filtrer les utilisateurs en fonction de la recherche
    const filteredGroupeUsers = groupeUsers.filter(user => 
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(searchGroupe.toLowerCase())
    );

    const filteredAllUsers = allUsers.filter(user => 
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(searchAll.toLowerCase())
    );

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className='d-flex align-items-center'><BsPeople size={25} className='mr-2'/>Mise en groupe  : <b> {groupeData.nom} </b></h2>
                        <small>Administration des groupes d'utilisateur.</small>

                        <small id='hbreadcrumb' className='d-flex justify-content-end'>
                            <ol className="breadcrumb custom-breadcrumb">
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                {/* Utiliser Link de react-router-dom pour la navigation */}
                                <Link to={`/admin`}> Administration</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                {/* Utiliser Link de react-router-dom pour la navigation */}
                                <Link to={`/Liste-groupe`}> Groupes</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                {/* Utiliser Link de react-router-dom pour la navigation */}
                                <Link> Mise en groupe <b> {groupeData.nom} </b></Link>
                                </li>
                            </ol>
                        </small>
                    </div>
                </div>
                    {/* <Header titre="Groupes" sous_titre="Dashboard" sous_titre1="Groupes" entete={`Ajouter utilisateur au groupe ${groupeData.nom}`} user_id={user_id} /> */}
                    <div className="container mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="row justify-content-center">
                                <div className="col-md-4">
                                    <h5>Utilisateurs du groupe</h5>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Rechercher..." 
                                        value={searchGroupe} 
                                        onChange={(e) => setSearchGroupe(e.target.value)} 
                                        className="mb-3"
                                    />
                                    <select
                                        multiple
                                        value={selectedGroupeUsers}
                                        onChange={(e) => setSelectedGroupeUsers([...e.target.selectedOptions].map(option => parseInt(option.value)))}
                                        className="form-control"
                                        style={{
                                            height: '320px',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            color: '#333',
                                            fontSize: '16px',
                                            marginBottom: '20px',
                                        }}
                                    >
                                        {filteredGroupeUsers.map(user => (
                                            <option key={user.id} value={user.id}>
                                                {user.nom} {user.prenoms}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-2 d-flex flex-column justify-content-center">
                                    <button onClick={ajouterTous} className="btn btn-dark mb-2">
                                        {"<< Ajouter tous"}
                                    </button>
                                    <button onClick={ajouterSelection} className="btn btn-dark mb-2">
                                        {"< Ajouter sélection"}
                                    </button>
                                    <button onClick={retirerSelection} className="btn btn-dark mb-2">
                                        {"Retirer sélection >"}
                                    </button>
                                    <button onClick={retirerTous} className="btn btn-dark">
                                        {"Retirer tous >>"}
                                    </button>
                                </div>

                                <div className="col-md-4">
                                    <h5>Utilisateurs disponibles</h5>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Rechercher..." 
                                        value={searchAll} 
                                        onChange={(e) => setSearchAll(e.target.value)} 
                                        className="mb-3"
                                    />
                                    <select
                                        multiple
                                        value={selectedAllUsers}
                                        onChange={(e) => setSelectedAllUsers([...e.target.selectedOptions].map(option => parseInt(option.value)))}
                                        className="form-control"
                                        style={{
                                            height: '320px',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            color: '#333',
                                            fontSize: '16px',
                                            marginBottom: '20px',
                                        }}
                                    >
                                        {filteredAllUsers.map(user => (
                                            <option key={user.id} value={user.id}>
                                                {user.nom} {user.prenoms}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="text-center mt-4">
                                <button onClick={handleSubmit} className="btn btn-success">
                                    Enregistrer les modifications
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de message */}
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalMessage}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Ajouter_utilisateur_groupe;
